import { type TLimits as TApiLimits } from '@core/api'

import { type TLimits } from '@core/models'

export const convertLimits = (limits: TApiLimits): TLimits => {
    return {
        maxProjects: limits.max_projects,
        maxCollaborators: limits.max_collaborators,
        maxStorage: limits.max_storage,
        maxProjectVersions: limits.max_project_versions,
        maxTotalAudioHours: limits.max_total_audio_hours,
        maxTotalMonthlyCleanVoicing: limits.max_total_monthly_clean_voicing,
        maxTotalMonthlyTranscriptions: limits.max_total_monthly_transcriptions,
    }
}
